(function (upp) {
    'use strict';
    upp.controller('upp.outlets.CatalogCtrl', ['$scope', 'outletsService', 'appi',
        function ($scope, outletsService, appi) {
            appi.ui.changeActualOption({moduleKey2Display:'outlets', navbarKey:'outlets'});
            $scope.listProducts = outletsService.listOutletsProducts;
        }]);
})(upp);


// WEBPACK FOOTER //
// ./src/app/modules/outlets/controllers/outlets-controllers.js